import { render, staticRenderFns } from "./ComunicationCard.vue?vue&type=template&id=65def67a&scoped=true"
import script from "./ComunicationCard.vue?vue&type=script&lang=js"
export * from "./ComunicationCard.vue?vue&type=script&lang=js"
import style0 from "./ComunicationCard.vue?vue&type=style&index=0&id=65def67a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65def67a",
  null
  
)

export default component.exports